import React from 'react';
import usePortalMessageHandler from '../Hooks/usePortalMessageHandler';

export default function API() {
    usePortalMessageHandler();
    return <React.Fragment/>;
}